import acquisitionAttributesFromQueryString from './acquisitionAttributesFromQueryString'
import { TouchPointAttributes } from '../types/touches'

export default function acquisitionAttributesFromWindow(): TouchPointAttributes {
  return {
    referrerUrl: window.document.referrer,
    initAppUrl: window.location.href,
    ...acquisitionAttributesFromQueryString(window.location.search)
  }
}
